import React, { useState } from 'react';
import PropTypes from 'prop-types';

const StyledContentFrame = ({ frame, url }) => {
	const [height, setHeight] = useState(0);

	return (
		<iframe
			className="pvi-no-styles"
			title={frame.tite}
			src={url}
			frameBorder="0"
			allowtransparency="true"
			width="100%"
			scrolling="no"
			style={{ height }}
			onLoad={(event) => {
				setHeight(event.target.contentWindow.document.body.scrollHeight);
			}}
		/>
	);
};

StyledContentFrame.propTypes = {
	frame: PropTypes.object.isRequired,
	url: PropTypes.string.isRequired
};

export default StyledContentFrame;
